import React from 'react'
import PropTypes from 'prop-types'

export default class AdLoader extends React.PureComponent {
  static propTypes = {
    id: PropTypes.number.isRequired,
    height: PropTypes.number,
    children: PropTypes.func.isRequired,
  }

  state = {
    error: null,
    height: null,
    width: null,
    loaded: false,
  }

  componentDidMount() {
    const adElement = document.getElementById(this.adSlotName)
    const config = { childList: true }
    const callback = mutationsList => {
      for (var mutation of mutationsList) {
        if (mutation.type == 'childList') {
          const [addedElement] = mutation.addedNodes
          if (addedElement && addedElement.id.indexOf('google_ads') > -1) {
            this.setSizes([addedElement.offsetWidth, addedElement.offsetHeight])
          }
        }
      }
    }

    this.observer = new MutationObserver(callback)
    this.observer.observe(adElement, config)
  }

  componentWillUnMount() {
    if (this.observer !== null) {
      this._setSizes(null)
      this.observer.disconnect()
    }
  }

  observer = null
  adSlotName = `ad-slot-${this.props.id}`

  setSizes(sizes) {
    let height = this.props.height,
      width = 0

    if (sizes && sizes.length) {
      width = sizes[0]
      height = sizes[1]
    }

    // always set ad slot to its height
    // to make sure it doesn't come over our modules
    document.getElementById(this.adSlotName).style.height = `${height}px`

    this.setState({ height, width, loaded: true })
  }

  render() {
    const { error, height, width, loaded } = this.state
    const { children } = this.props

    if (error || !loaded) return null

    return children({ height, width })
  }
}
